import { match } from 'ts-pattern'
import i18next from 'i18next'
import type { TargetCostOtherMutator } from '@/lib/entity/target_cost_other'
import type { Converter } from '@/lib/converter/entityFormatter'
import { asModifiedField } from '@/lib/converter/entityFormatter'

type TargetCostOtherSchema = TargetCostOtherMutator['merged']

export const TargetCostOtherConverter: Converter<TargetCostOtherSchema> = {
  icon: () => i18next.t('stages.icon.target_cost_other'),
  title: () => i18next.t('stages.table.target_cost_other'),
  subTitle: async (merged) => merged.name ?? i18next.t('ui.common.inputting'),
  modifiedFields: (modified, column) => {
    const label = i18next.t(`stages.labels.target_cost_other.${column}`)

    return match(column)
      .with('name', () => asModifiedField(label, modified.name != null ? modified.name : '-'))
      .with('costs_plan', async () => {
        const costs: { offset: number; cost: number }[] =
          modified.costs_plan !== undefined ? JSON.parse(modified.costs_plan) : []

        return await asModifiedField(label, costs.map((cost) => cost.cost.toString()).join(','))
      })
      .with('id', 'project_id', async (column) => asModifiedField(label, modified[column]!))
      .exhaustive()
  }
}
